import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  storageDetails: {},
};
const storageDetailsSlice = createSlice({
  name: "storageDetails",
  initialState,
  reducers: {
    updateStorageDetails: (state, action) => {
      state.storageDetails = action.payload.storageDetails;
    },
  },
});

export const { updateStorageDetails } = storageDetailsSlice.actions;
export default storageDetailsSlice;
